


<div class="contentBox" *ngIf="!loading">
    <app-ui-preloader id="spinner" [display]="loading"></app-ui-preloader>

    <div *ngIf="tasksList.lenght == 0">
        {{'BOARD.TIMESLIST.EMPTY' |translate}}

    </div>

    <div *ngFor="let task of tasksList">
        <app-times-info-top-bar-card [task]="task"> </app-times-info-top-bar-card>
    </div>

</div>
